import { BeamIcon } from 'beam'
import { IconButton, makeStyles, Snackbar, SnackbarProps } from 'beam'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => {
  const topOffset = theme.spacing(7)
  return {
    anchorOriginTopLeft: {
      top: topOffset,
    },
    anchorOriginTopCenter: {
      top: topOffset,
    },
    anchorOriginTopRight: {
      top: topOffset,
      right: theme.spacing(0.5),
    },
    snackbarError: {
      backgroundColor: theme.palette.error.main,
    },
    snackbarSuccess: {
      backgroundColor: theme.palette.success.main,
    },
  }
})

/** @deprecated instead `import { SnackbarProps } from '@mui/material` */
export interface NguiSnackbarProps extends SnackbarProps {
  closeCallback?: () => void,
  variant?: 'success' | 'error',
}

/**
 * Snackbar styled for consistency within NGUI
 * Auto-hides after 3.5 seconds if there is no error, defaults to display at the top-center of the screen
 * and displays a 'close' button on the right side of the snackbar if a callback for the 'open' state is provided
 * @deprecated instead `import { Snackbar } from '@mui/material`
 */
export function NguiSnackbar({ open = true, variant = 'success', closeCallback, autoHideDuration = 3500, ...restProps }: NguiSnackbarProps): ReactElement {
  const { t } = useTranslation()
  const classes = useStyles()
  return (
    <Snackbar
      open={open}
      className={classes.anchorOriginTopCenter}
      autoHideDuration={variant === 'success' ? autoHideDuration : null}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      ContentProps={{ className: variant === 'error' ? classes.snackbarError : classes.snackbarSuccess }}
      action={
        closeCallback && (
          <IconButton key="close" aria-label={t('close')} color="inherit" onClick={closeCallback}>
            <BeamIcon>Close</BeamIcon>
          </IconButton>
        )
      }
      {...restProps}
    />
  )
}

export default NguiSnackbar
